import * as React from 'react';
import styles from './index.less';
import FIcons from '@/components/FIcons';
import FRectBtn from '@/components/FButton/FRectBtn';
// import FPopover from '@/components/FPopover';
import FTooltip from '@/components/FTooltip';
// import { history } from 'umi';
import { FI18n, FServiceAPI, FUtil } from '@freelog/tools-lib';
import fMessage from '@/components/fMessage';
import * as AHooks from 'ahooks';
import FComponentsLib from '@freelog/components-lib';
import dayjs from 'dayjs';
// import FListFooter from '@/components/FListFooter';
import FNoDataTip from '@/components/FNoDataTip';
import FWithdrawModal from '@/pages/node/formal/$id/Income/FWithdrawModal';
import fPromiseModalConfirm from '@/components/fPromiseModalConfirm';

interface IncomeProps { }

interface WithdrawalRecord {
  id: string;
  date: string;
  amount: string;
  method: string;
  cardNumber: string;
  description: string;
  status: 'processing' | 'success' | 'failed';
  failureReason?: string;
}

interface IncomeStates {
  noWithdrawable: {
    reason: '' | 'noAccount' | 'noBankCard' | 'noWithdrawableAmount' | 'within24Hours';
    message: string;
  };
  accountId: string;
  withdrawableAmount: number;
  last30DaysIncome: number;
  totalIncome: number;
  withdrawalRecords: WithdrawalRecord[];

  // listState: 'loading' | 'noData' | 'noSearchResult' | 'loaded';
  // listMore: 'loading' | 'andMore' | 'noMore';
  showWithdrawModal: boolean;
}

const initStates: IncomeStates = {
  noWithdrawable: {
    reason: '',
    message: '',
  },
  accountId: '',
  withdrawableAmount: -1,
  last30DaysIncome: -1,
  totalIncome: -1,
  withdrawalRecords: [],

  // listState: 'loading',
  // listMore: 'loading',
  showWithdrawModal: false,
};

function Income({ }: IncomeProps) {
  const [$noWithdrawable, set$noWithdrawable, get$noWithdrawable] = FUtil.Hook.useGetState<
    IncomeStates['noWithdrawable']
  >(initStates['noWithdrawable']);
  const [$accountId, set$accountId, get$accountId] = FUtil.Hook.useGetState<
    IncomeStates['accountId']
  >(initStates['accountId']);
  const [$withdrawableAmount, set$withdrawableAmount, get$withdrawableAmount] =
    FUtil.Hook.useGetState<IncomeStates['withdrawableAmount']>(initStates['withdrawableAmount']);
  const [$last30DaysIncome, set$last30DaysIncome, get$last30DaysIncome] = FUtil.Hook.useGetState<
    IncomeStates['last30DaysIncome']
  >(initStates['last30DaysIncome']);
  const [$totalIncome, set$totalIncome, get$totalIncome] = FUtil.Hook.useGetState<
    IncomeStates['totalIncome']
  >(initStates['totalIncome']);
  const [$withdrawalRecords, set$withdrawalRecords, get$withdrawalRecords] = FUtil.Hook.useGetState<
    IncomeStates['withdrawalRecords']
  >(initStates['withdrawalRecords']);

  // const [$listState, set$listState, get$listState] = FUtil.Hook.useGetState<
  //   IncomeStates['listState']
  // >(initStates['listState']);
  // const [$listMore, set$listMore, get$listMore] = FUtil.Hook.useGetState<IncomeStates['listMore']>(
  //   initStates['listMore'],
  // );

  const [$showWithdrawModal, set$showWithdrawModal, get$showWithdrawModal] = FUtil.Hook.useGetState<
    IncomeStates['showWithdrawModal']
  >(initStates['showWithdrawModal']);

  AHooks.useMount(async () => {
    handleStatus();
  });

  // 从开户页返回时刷新卡片数据
  React.useEffect(() => {
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        handleStatus();
      }
    };
    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => document.removeEventListener('visibilitychange', onVisibilityChange);
  }, []);

  async function handleStatus() {
    const {
      ret,
      errCode,
      msg,
      data,
    }: {
      ret: number;
      errCode: number;
      msg: string;
      data: {
        status: number;
        msg?: string;
        data?: {
          latestOperationDate?: string;
          availableBalance?: number;
        };
      };
    } = await FServiceAPI.Payment.queryWithdrawStatus({
      ownerId: FUtil.Tool.getUserIDByCookies(),
      accountType: 1,
    });
    if (ret !== 0 || errCode !== 0) {
      fMessage(msg, 'error');
      return;
    }
    if (data.status === 1) {
      set$noWithdrawable({
        reason: 'noAccount',
        message:
          // 还未设置结算信息，这是必要的提现条件
          FI18n.i18nNext.t('payouts_info_addpayoutmethod'),
      });
    } else if (data.status === 2) {
      set$noWithdrawable({
        reason: 'noWithdrawableAmount',
        message: '',
      });
    } else if (data.status === 3) {
      set$noWithdrawable({
        reason: 'within24Hours',
        // message: `${
        //   // 每24小时仅可提现一次，在${dayjs(data.latestOperationDate)之前您的提现功能将暂停使用。
        //   FI18n.i18nNext.tAuto('payouts_msg_24hourwaiting')
        //   } ${dayjs(data.data?.latestOperationDate)
        //     .add(1, 'day')
        //     .format('YYYY-MM-DD HH:mm:ss')}`,
        message:
          FI18n.i18nNext.t('payouts_msg_24hourwaiting', {
            timer: dayjs(data.data?.latestOperationDate)
              .add(1, 'day')
              .format('YYYY-MM-DD HH:mm:ss')
          })
      });
    } else if (data.status === 4) {
      set$noWithdrawable({
        reason: 'noBankCard',
        message:
          // '还未设置提现银行卡，这是必要的提现条件',
          FI18n.i18nNext.t('payouts_info_addpayoutmethod'),
      });
    }

    if (data.status !== 1) {
      handleListData();
    }
  }

  async function handleListData() {
    const {
      ret,
      errCode,
      msg,
      data,
    }: {
      ret: number;
      errCode: number;
      msg: string;
      data: {
        accountType: 1;
        availableBalance: number;
        certName: string;
        certNo: string;
        createDate: string;
        currencyType: number;
        freezeBalance: number;
        id: string;
        ownerId: number;
        ownerName: string;
        ownerUserId: number;
        ownerUserName: string;
        status: number;
        totalBalance: number;
        totalExpenditureAmount: number;
        totalIncomeAmount: number;
      };
    } = await FServiceAPI.Payment.queryFinancialAccountInfo({
      accountType: 1,
      ownerId: FUtil.Tool.getUserIDByCookies(),
    });
    if (ret !== 0 || errCode !== 0) {
      fMessage(msg, 'error');
      return;
    }

    if (!data) {
      return;
    }
    set$accountId(data.id);
    set$withdrawableAmount(data.availableBalance);

    // 与 dashboard 资源「近30日收益」一致：Payment.queryStatistics + 近30天日期区间（见 dashboardPage onMount_Page）
    const startTime = dayjs().subtract(29, 'days').format(FUtil.Predefined.momentDateFormat);
    const endTime = dayjs().format(FUtil.Predefined.momentDateFormat);
    const {
      ret: retLast30,
      errCode: errCodeLast30,
      msg: msgLast30,
      data: dataLast30,
    }: {
      ret: number;
      errCode: number;
      msg: string;
      data: { depositAmount: number; withdrawalAmount: number };
    } = await FServiceAPI.Payment.queryStatistics({
      ownerType: 1,
      startTransactionDate: startTime,
      endTransactionDate: endTime,
    });
    if (retLast30 !== 0 || errCodeLast30 !== 0) {
      fMessage(msgLast30, 'error');
      return;
    }
    set$last30DaysIncome(dataLast30.depositAmount);
    set$totalIncome(data.totalIncomeAmount);

    const {
      ret: ret2,
      errCode: errCode2,
      msg: msg2,
      data: data2,
    }: {
      ret: number;
      errCode: number;
      msg: string;
      data: {
        dataList: {
          id: string;
          transactionInitiationDate: string;
          transactionAmount: number;
          cardNo: string;
          status: 1 | 2 | 3; // 提现状态 1:处理中 2:成功 3:失败
          remark: string;
          withdrawCashType: string;
        }[];
      };
    } = await FServiceAPI.Payment.queryWithdrawCashList({
      accountId: data.id,
      skip: 0,
      limit: 100,
    });
    if (ret2 !== 0 || errCode2 !== 0) {
      fMessage(msg, 'error');
      return;
    }

    // console.log(data2), '89wieofjsdl;kjlkjfaschsdaenlksxcjflk';
    set$withdrawalRecords(
      data2.dataList.map((item) => ({
        id: item.id,
        date: dayjs(item.transactionInitiationDate).format('YYYY-MM-DD HH:mm:ss'),
        amount: item.transactionAmount.toString(),
        method: item.withdrawCashType,
        cardNumber: item.cardNo,
        description: '手动提现',
        status: item.status === 1 ? 'processing' : item.status === 2 ? 'success' : 'failed',
        failureReason: item.status === 3 ? item.remark : undefined,
      })),
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.revenueModule}>
        <div className={styles.withdrawableCard}>
          <div className={styles.cardHeader}>
            <div className={styles.titleRow}>
              <div className={styles.titleWithIcon}>
                <span className={styles.titleBold}>
                  {
                    // 可提现金额（元）
                    FI18n.i18nNext.tAuto('payouts_availabletowithdraw')
                  }
                </span>
                <div className={styles.infoIcon}>
                  <FTooltip
                    styles={{ body: { width: 340 } }}
                    placement={'bottomRight'}
                    title={
                      <div className={styles.tooltipTitle}>
                        {/* <div>可提现金额是完成结算可以提现的收入金额</div> */}
                        {
                          FI18n.i18nNext.tAuto('payouts_availabletowithdraw_info')
                        }
                        <div style={{ height: 5 }} />
                        {/* <div>
                          付款方完成支付后，收入会在指定时间进入待结算金额。待结算金额是扣除了交易费用的收入金额。
                        </div>
                        <div style={{ height: 20 }} />
                        <div>待结算金额（元）/ 费率0.6%</div> */}
                        {
                          FI18n.i18nNext.tAuto('payouts_availabletowithdraw_info2')
                        }
                      </div>
                    }
                  >
                    <span style={{ cursor: 'pointer' }}>
                      <FIcons.FInfo style={{ fontSize: 16, width: 16, height: 16 }} />
                    </span>
                  </FTooltip>
                </div>
              </div>
              {$accountId && (
                <a
                  className={styles.settlementLink}
                  onClick={async () => {

                    self.open(
                      FUtil.LinkTo.settlementInfo({
                        accountID: get$accountId(),
                      }),
                    );
                  }}
                >
                  {
                    // 结算信息
                    FI18n.i18nNext.tAuto('payouts_btn_payoutsettings')
                  }
                </a>
              )}
            </div>
          </div>
          <div className={styles.cardContent}>
            <span className={styles.amountLarge}>
              {$withdrawableAmount === -1 ? '--' : $withdrawableAmount.toFixed(2)}
            </span>
            <div className={styles.withdrawActionArea}>
              {$noWithdrawable.reason !== '' && (
                <div className={styles.withdrawTip}>
                  <FComponentsLib.FContentText type={'additional1'} text={$noWithdrawable.message} />
                  {$noWithdrawable.reason === 'noAccount' && (
                    <FComponentsLib.FTextBtn
                      type={'primary'}
                      onClick={async () => {
                        const { data }: { data: { mobile: string } } = await FServiceAPI.User.currentUserInfo();
                        if (!data?.mobile) {
                          const bool = await fPromiseModalConfirm({
                            title: '提示',
                            description:
                              FI18n.i18nNext.t('payout_setting_alert_no_mobileno_msg'),
                            okText:
                              FI18n.i18nNext.t('payout_setting_alert_no_mobileno_btn_ok'),
                            cancelText:
                              FI18n.i18nNext.t('payout_setting_alert_no_mobileno_btn_later'),
                          });
                          if (!bool) return;
                          self.open(
                            FUtil.Format.completeUrlByDomain('user') +
                              FUtil.LinkTo.setting() +
                              '?type=security',
                          );
                          return;
                        }
                        self.open(FUtil.LinkTo.settlementInfoCreator({}));
                      }}
                      style={{ fontSize: 12 }}
                    >
                      {
                        // 前往设置
                        FI18n.i18nNext.tAuto('payouts_btn_addpayoutmethod')
                      }
                    </FComponentsLib.FTextBtn>
                  )}
                  {$noWithdrawable.reason === 'noBankCard' && (
                    <FComponentsLib.FTextBtn
                      type={'primary'}
                      onClick={() => {
                        self.open(
                          FUtil.LinkTo.settlementBankCardEditor({
                            accountID: get$accountId(),
                          }),
                        );
                      }}
                      style={{ fontSize: 12 }}
                    >
                      {
                        // 前往设置
                        FI18n.i18nNext.tAuto('payouts_btn_addpayoutmethod')
                      }
                    </FComponentsLib.FTextBtn>
                  )}
                </div>
              )}
              <FRectBtn
                disabled={$noWithdrawable.reason !== ''}
                type='primary'
                onClick={async () => {
                  set$showWithdrawModal(true);
                }}
              >
                {
                  // 提现
                  FI18n.i18nNext.tAuto('payouts_btn_withdraw')
                }
              </FRectBtn>
            </div>
          </div>
        </div>

        <div className={styles.statsCards}>
          <div className={styles.statCard}>
            <div className={styles.statContent}>
              <div className={styles.statTitle}>
                <span className={styles.statTitleText}>{
                  // 近30天收入（元）
                  FI18n.i18nNext.tAuto('payouts_last30days')
                }</span>
              </div>
              <div className={styles.statAmount}>
                <span className={styles.amountMedium}>
                  {$last30DaysIncome === -1 ? '--' : $last30DaysIncome.toFixed(2)}
                </span>
              </div>
            </div>
          </div>

          <div className={styles.divider}></div>

          <div className={styles.statCard}>
            <div className={styles.statContent}>
              <div className={styles.statTitle}>
                <span className={styles.statTitleText}>{
                  // 总收入（元）
                  FI18n.i18nNext.tAuto('payouts_alltime')
                }</span>
              </div>
              <div className={styles.statAmount}>
                <span className={styles.amountMedium}>
                  {$totalIncome === -1 ? '--' : $totalIncome.toFixed(2)}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {
        $withdrawalRecords.length > 0 && (<div className={styles.withdrawalRecords}>
          <div className={styles.recordsHeader}>
            <span className={styles.recordsTitle}>{
              // 提现记录
              FI18n.i18nNext.tAuto('nodemgnt_payouts_history_title')
            }</span>
          </div>

          <div className={styles.table}>
              <div className={styles.tableHeader}>
                <div className={styles.headerCell}>
                  <span className={styles.headerText}>{
                    // 日期
                    FI18n.i18nNext.tAuto('payoutshistory_list_date')
                  }</span>
                </div>
                <div className={styles.headerCell}>
                  <span className={styles.headerText}>{
                    // 金额（元）
                    FI18n.i18nNext.tAuto('payoutshistory_list_amount')
                  }</span>
                </div>
                <div className={styles.headerCell}>
                  <span className={styles.headerText}>{
                    // 提现方式
                    FI18n.i18nNext.tAuto('payoutshistory_list_payoutmethod')
                  }</span>
                </div>
                <div className={styles.headerCell}>
                  <span className={styles.headerText}>{
                    // 说明
                    FI18n.i18nNext.tAuto('payoutshistory_list_desc')
                  }</span>
                </div>
                <div className={styles.headerCellStatus}>
                  <span className={styles.headerText}>{
                    // 状态
                    FI18n.i18nNext.tAuto('payoutshistory_list_status')
                  }</span>
                </div>
              </div>
              <div style={{ width: '100%', height: '1px', backgroundColor: '#E4E7EB' }} />
              <div className={styles.tableBody}>
                {$withdrawalRecords.map((record, index) => (
                  <React.Fragment key={record.id}>
                    <div className={styles.tableRow}>
                      <div className={styles.bodyCell}>
                        <span className={styles.bodyText}>{record.date}</span>
                      </div>
                      <div className={styles.bodyCell}>
                        <span className={styles.amountBold}>{record.amount}</span>
                      </div>
                      <div className={styles.bodyCell}>
                        <div className={styles.methodInfo}>
                          <span className={styles.bodyText}>{record.method}</span>
                          <span className={styles.bodyText}>{record.cardNumber}</span>
                        </div>
                      </div>
                      <div className={styles.bodyCell}>
                        <span className={styles.bodyText}>{record.description}</span>
                      </div>
                      <div
                        className={`${styles.bodyCellStatus} ${record.status === 'failed' ? styles.statusFailedCell : ''
                          }`}
                      >
                        <div className={styles.statusWrapper}>
                          <span className={`${styles.statusText} ${getStatusColor(record.status)}`}>
                            {getStatusText(record.status)}
                          </span>
                          {record.status === 'failed' && record.failureReason && (
                            <a className={styles.failureLink}>{record.failureReason}</a>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className={styles.rowDivider}></div>
                  </React.Fragment>
                ))}
              </div>
            </div>
        </div>)
      }

      {/* <FListFooter state={'andMore'} onClickLoadMore={() => {}} /> */}
      <FWithdrawModal
        accountID={$accountId}
        open={$showWithdrawModal}
        availableAmount={$withdrawableAmount}
        onCancel={() => {
          set$showWithdrawModal(false);
        }}
        onOk={(amount) => {
          set$showWithdrawModal(false);
          handleStatus();
        }}
      />
    </div>
  );
}

export default Income;

function getStatusText(status: string) {
  switch (status) {
    case 'processing':
      return '处理中';
    case 'success':
      return '成功';
    case 'failed':
      return '失败';
    default:
      return '';
  }
}

function getStatusColor(status: string) {
  switch (status) {
    case 'processing':
      return styles.statusProcessing;
    case 'success':
      return styles.statusSuccess;
    case 'failed':
      return styles.statusFailed;
    default:
      return '';
  }
}
